module.exports = __webpack_public_path__ + "img/bg.6e6672d2.png";